import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, AppContextType } from '@contexts/AppContext';
import { TI50Props } from '@interfaces/ti50';

import Layout from './Layout';
import TIFifty2020Header from './TIFifty2020/Header';
import TIFifty2021Header from './TIFifty2021/Header';
import TIFifty2022Header from './TIFifty2022/Header';
import TIFifty2023Header from './TIFifty2023/Header';
import TIFifty2024Header from './TIFifty2024/Header';
import TIFifty2025Header from './TIFifty2025/Header';

const queryClient = new QueryClient();

const getHeader = (TI50Year: number) => {
  switch (TI50Year) {
    case 2020:
      return TIFifty2020Header;
    case 2021:
      return TIFifty2021Header;
    case 2022:
      return TIFifty2022Header;
    case 2023:
      return TIFifty2023Header;
    case 2024:
      return TIFifty2024Header;
    case 2025:
      return TIFifty2025Header;
  }
};

const TI50 = ({
  env,
  initialCurrentUser,
  isWebview,
  ...restProps
}: Omit<AppContextType, 'isGdprRequired'> & TI50Props): JSX.Element => {
  const Header = getHeader(restProps.TI50Year);

  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Layout {...restProps} Header={Header} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default TI50;
